/**
 * 
 * @param {number} hourNumber
 * 
 * @returns {number} in milliseconds  
 */
export function hourInMs(hourNumber){
  return hourNumber * 3600000;
}